function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _require = require('../../utils.js'),
  round = _require.round;
function _getAuthorizedAmount(total) {
  var authorizationMultiplier = 1.1;
  var amount = round(total * authorizationMultiplier);
  return amount < 0 ? 0 : amount;
}
var _export = function _export(items, purchaseService, _ref) {
  var basket_data = _ref.basket_data,
    delivery_amount = _ref.delivery_amount,
    points_config_enabled = _ref.points_config_enabled;
  var cashDiscount = purchaseService.priceIncrease && purchaseService.feeBusterConfig.enabled;
  var deliveryAmount = delivery_amount || 0;
  var total = purchaseService.totals.total() + deliveryAmount;
  var result = Object.assign({}, _objectSpread({
    items: items,
    totals: _objectSpread({
      authorizedAmount: _getAuthorizedAmount(total),
      br: purchaseService.totals.promos('br'),
      coupons: purchaseService.totals.promos('coupons'),
      deliveryAmount: delivery_amount,
      discount: purchaseService.totals.manualdiscountAndPriceoverride(),
      driverTip: purchaseService.totals.driverTip(),
      fee: purchaseService.totals.fee(),
      promo: purchaseService.totals.promos('promo'),
      saving: purchaseService.totals.promos(),
      serviceFee: purchaseService.totals.serviceFee(),
      storeTip: purchaseService.tipsInformations,
      subTotal: purchaseService.totals.subtotal() + deliveryAmount,
      subtotal: purchaseService.totals.subtotal() + deliveryAmount,
      tax: purchaseService.totals.tax(),
      taxFreeSaleReduction: purchaseService.totals.taxFreeSaleReduction(),
      total: total,
      totalSpentForPoints: points_config_enabled ? purchaseService.totals.totalSpentForPoints(false, true) : 0
    }, cashDiscount && {
      cash: {
        br: purchaseService.totals.promos('br', 'cash'),
        discount: purchaseService.totals.manualdiscountAndPriceoverride('cash'),
        coupons: purchaseService.totals.promosCash('coupons'),
        fee: purchaseService.totals.fee('cash'),
        promo: purchaseService.totals.promosCash('promo'),
        saving: purchaseService.totals.promosCash(),
        storeTip: purchaseService.tipsInformations,
        subtotal: purchaseService.totals.subtotal('cash'),
        tax: purchaseService.totals.tax('cash'),
        taxFreeSaleReduction: purchaseService.totals.taxFreeSaleReduction('cash'),
        total: purchaseService.totals.total('cash'),
        totalSpentForPoints: points_config_enabled ? purchaseService.totals.totalSpentForPoints('cash', true) : 0
      }
    })
  }, basket_data && {
    basketdata: {
      payments: purchaseService.payments,
      purchases: delivery_amount ? [].concat(_toConsumableArray(purchaseService.purchases), [items.deliveryitem]) : purchaseService.purchases.slice(0),
      priceTaxFeeAdjusters: purchaseService.priceTaxFeeAdjusters,
      basket: purchaseService.basket,
      // null as well
      overrides: purchaseService.overrides,
      reg: _objectSpread({}, purchaseService.reg),
      brnumber: purchaseService.reg.brnumber,
      // storefront passes in true always
      tipsInformations: purchaseService.tipsInformations
    }
  }));
  purchaseService.clearRegister();
  return result;
};
module.exports = _export;